import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.search.js";
import { defineComponent as _defineComponent } from 'vue';
import _ from 'lodash';
import { AccountMembershipRole, useListUsersQuery, useSetAccountUserRolesMutation, useSetIxAdminMutation, useUpdateAccountMutation } from '~/types/types';
import { formatAsGermanDate } from '~/functions/helpers';
import { isIxUserEmail } from '~/functions/membership-role';
export default /*#__PURE__*/_defineComponent({
  __name: 'Users',
  props: {
    value: {
      default: function _default() {
        return [];
      }
    },
    modelValue: null,
    mode: {
      default: 'ix-admin'
    },
    accountId: null,
    disableReviewer: {
      type: Boolean,
      default: false
    },
    showAdminRole: {
      type: Boolean,
      default: false
    },
    columns: {
      default: function _default() {
        return ['name'];
      }
    },
    filter: {
      default: function _default() {
        return {};
      }
    }
  },
  emits: ["input", "update:modelValue"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var headers = computed(function () {
      return [{
        value: 'email'
      }, {
        value: 'firstName'
      }, {
        value: 'lastName'
      }, {
        value: 'roles',
        width: 450
      }, {
        value: 'isIxAdmin',
        width: 120
      }, {
        value: 'accounts'
      }, {
        value: 'lastLogin',
        width: 140
      }, {
        value: 'actions',
        width: 88,
        align: 'center'
      }].filter(function (o) {
        var _props$columns;
        return (_props$columns = props.columns) === null || _props$columns === void 0 ? void 0 : _props$columns.includes(o.value);
      });
    });
    var options = ref({
      page: 1,
      itemsPerPage: 15,
      search: ''
    });
    var variables = computed(function () {
      return _objectSpread(_objectSpread({}, props.filter), {}, {
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage,
        search: options.value.search || ''
      });
    });
    var _useListUsersQuery = useListUsersQuery(variables),
      result = _useListUsersQuery.result,
      refetch = _useListUsersQuery.refetch,
      loading = _useListUsersQuery.loading;
    var _useSetAccountUserRol = useSetAccountUserRolesMutation(),
      setAccountUserRoles = _useSetAccountUserRol.mutate;
    var _useSetIxAdminMutatio = useSetIxAdminMutation(),
      setIxAdmin = _useSetIxAdminMutatio.mutate;
    var _useUpdateAccountMuta = useUpdateAccountMutation(),
      updateAccount = _useUpdateAccountMuta.mutate;
    var items = computed(function () {
      var _result$value$listUse, _result$value;
      return (_result$value$listUse = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listUsers) !== null && _result$value$listUse !== void 0 ? _result$value$listUse : [];
    });

    // Prefer modelValue when provided, fall back to legacy value
    var currentIds = computed(function () {
      return (props.modelValue !== undefined ? props.modelValue : props.value) || [];
    });
    var selected = computed(function () {
      return items.value.filter(function (user) {
        return currentIds.value.filter(Boolean).includes(user.id || '');
      });
    });
    var onInput = function onInput(val) {
      var nextIds = val.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      });
      if (_.isEqual(nextIds, currentIds.value)) {
        // if the value is the same, don't fire the event
        return;
      }
      emit('update:modelValue', nextIds);
      emit('input', nextIds);
    };
    var itemCount = computed(function () {
      var _result$value2;
      return ((_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countUsers) || 0;
    });
    var normalizeRoles = function normalizeRoles(roles) {
      if (Array.isArray(roles)) {
        return roles;
      }
      if (roles) {
        return [roles];
      }
      return [AccountMembershipRole.Editor];
    };
    var onRolesChange = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(item, roles) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(props.mode !== 'account-admin' || !props.accountId || !item.id)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return setAccountUserRoles({
                accountId: props.accountId,
                userId: item.id,
                roles: normalizeRoles(roles)
              });
            case 4:
              _context.next = 6;
              return refetch();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function onRolesChange(_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    var onIxAdminChange = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(item, isIxAdmin) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(props.mode !== 'ix-admin' || !item.id)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return setIxAdmin({
                userId: item.id,
                isIxAdmin: Boolean(isIxAdmin)
              });
            case 5:
              _context2.next = 7;
              return refetch();
            case 7:
              _context2.next = 14;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](2);
              window.$nuxt.$emit('userError', _objectSpread(_objectSpread({}, _context2.t0), {}, {
                color: 'red'
              }));
              _context2.next = 14;
              return refetch();
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 9]]);
      }));
      return function onIxAdminChange(_x3, _x4) {
        return _ref4.apply(this, arguments);
      };
    }();
    var removeDialogOpen = ref(false);
    var userToRemove = ref(null);
    var removeLoading = ref(false);
    var openRemoveDialog = function openRemoveDialog(item) {
      if (props.mode !== 'account-admin') {
        return;
      }
      userToRemove.value = item;
      removeDialogOpen.value = true;
    };
    var confirmRemoveUser = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _userToRemove$value;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!props.accountId || !((_userToRemove$value = userToRemove.value) !== null && _userToRemove$value !== void 0 && _userToRemove$value.id))) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              _context3.prev = 2;
              removeLoading.value = true;
              _context3.next = 6;
              return updateAccount({
                input: {
                  id: props.accountId
                },
                userIdsToRemove: [userToRemove.value.id]
              });
            case 6:
              removeDialogOpen.value = false;
              userToRemove.value = null;
              _context3.next = 10;
              return refetch();
            case 10:
              _context3.prev = 10;
              removeLoading.value = false;
              return _context3.finish(10);
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2,, 10, 13]]);
      }));
      return function confirmRemoveUser() {
        return _ref5.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      emit: emit,
      headers: headers,
      options: options,
      variables: variables,
      result: result,
      refetch: refetch,
      loading: loading,
      setAccountUserRoles: setAccountUserRoles,
      setIxAdmin: setIxAdmin,
      updateAccount: updateAccount,
      items: items,
      currentIds: currentIds,
      selected: selected,
      onInput: onInput,
      itemCount: itemCount,
      normalizeRoles: normalizeRoles,
      onRolesChange: onRolesChange,
      onIxAdminChange: onIxAdminChange,
      removeDialogOpen: removeDialogOpen,
      userToRemove: userToRemove,
      removeLoading: removeLoading,
      openRemoveDialog: openRemoveDialog,
      confirmRemoveUser: confirmRemoveUser,
      formatAsGermanDate: formatAsGermanDate,
      isIxUserEmail: isIxUserEmail
    };
  }
});